export const safeString = (value) => {
  if (value === undefined || value === null) {
    return undefined;
  }
  try {
    return String(value);
  } catch (error) {
    return undefined;
  }
};

export const safeNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : undefined;
};

export const safeBoolean = (value) => {
  if (value === undefined || value === null) {
    return undefined;
  }
  return Boolean(value);
};

export const isoTimestamp = (date = new Date()) => {
  try {
    return date.toISOString();
  } catch (error) {
    return undefined;
  }
};

export const stripUndefined = (object) => {
  if (!object) {
    return {};
  }
  return Object.keys(object).reduce((accumulator, key) => {
    const value = object[key];
    if (value !== undefined && value !== null) {
      accumulator[key] = value;
    }
    return accumulator;
  }, {});
};

export const flattenArray = (value) => {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.filter((item) => item !== undefined && item !== null);
};

export const getFromSessionStorage = (key) => {
  if (typeof window === "undefined") {
    return undefined;
  }
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    return undefined;
  }
};

export const setInSessionStorage = (key, value) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    // ignore storage errors (private mode, etc.)
  }
};

export const getFromLocalStorage = (key) => {
  if (typeof window === "undefined") {
    return undefined;
  }
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return undefined;
  }
};

export const buildItemId = ({
  seasonCode,
  collectionCode,
  modelCode,
  materialCode,
  colorCode,
}) => {
  const parts = [seasonCode, collectionCode, modelCode, materialCode, colorCode]
    .filter(Boolean)
    .map((part) => String(part).replace(/\s+/g, ""));

  if (!parts.length) {
    return undefined;
  }

  return parts.join("_");
};
